const configs = {
  API_DOMAIN: process.env.REACT_APP_API_DEV,
  DEVICE_ID: process.env.REACT_APP_DEVICE_ID || '',
  FIREBASE_TOKEN: process.env.REACT_APP_FIREBASE_TOKEN || '',
  SRC_RQ: process.env.REACT_APP_SRC_RQ || '',
  USER_TYPE: process.env.REACT_APP_USER_TYPE || '',
};

export default configs;
